import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=051fcde8&scoped=true&"
import script from "./wallet.vue?vue&type=script&lang=js&"
export * from "./wallet.vue?vue&type=script&lang=js&"
import style0 from "./wallet.vue?vue&type=style&index=0&id=051fcde8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051fcde8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('051fcde8')) {
      api.createRecord('051fcde8', component.options)
    } else {
      api.reload('051fcde8', component.options)
    }
    module.hot.accept("./wallet.vue?vue&type=template&id=051fcde8&scoped=true&", function () {
      api.rerender('051fcde8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/my/wallet.vue"
export default component.exports